import {ChangeDetectionStrategy, Component, Input} from '@angular/core';

@Component({
  selector: 'app-title',
  template: `
    <h2 class="patient-desktop">
      {{ 'reason_patient' | locale }}
      <span class="patient-name">
          {{ name }}
        </span>
    </h2>
  `,
  styles: [`
    h2.patient-desktop {
      display: flex;
      flex-direction: column;
      align-items: start;
      font-size: .85rem;
      line-height: 1.05rem;
    }

    h2.patient-desktop .patient-name {
      color: var(--contrast-custom-button-color, var(--dark-base-color));
      max-width: 250px;
      border-radius: 25px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      font-weight: bold;
      display: inline-block;
      padding: 8px 16px;
    }

    @media (max-width:959px)  {
      h2.patient-desktop {
        font-size: .85rem !important;
        align-items: start;
      }

      h2.patient-desktop .patient-name {
        background-color: transparent;
        color: var(--white-label-white, var(--primary-base-color));
        overflow: initial;
        width: initial;
        white-space: initial;
        padding-top: 0;
      }
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class TitleComponent {
  @Input() name: string | undefined = ''
}
